import { useEffect } from "react";
import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { UserContextType, useUserContext } from "@contexts/UserContext";

export default function useOnUserDataLoaded(action: (userData: UserEntity) => void) {
    const { user, loading, userData }: UserContextType = useUserContext();

    useEffect(() => {
        if (!loading && user && userData) {
            action(userData);
        }
        // NOTE: intentionally omitted userData and action. non-exhaustive dep.
    }, [user?.uid, loading]);
}
